module.exports = __webpack_public_path__ + "img/stacked_line_chart.d28d8c4f.svg";